<ng-template #topUpBody>
  <div class="tw-flex tw-flex-col tw-gap-2 tw-min-h-0 tw-font-inter">
    <div class="tw-flex tw-flex-col tw-gap-4">
      <p class="tw-font-medium tw-text-base tw-text-gray-900 dark:tw-text-gray-100">
        {{ 'v2.orgSettings.billing.topUpAmount' | translate }}
      </p>

      <div
        class="tw-w-full tw-overflow-x-auto lg:tw-overflow-visible tw-snap-x tw-snap-mandatory lg:tw-snap-none [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:tw-hidden"
      >
        <div class="tw-flex tw-flex-row tw-flex-nowrap tw-gap-2 tw-w-max lg:tw-w-full lg:tw-grid lg:tw-grid-cols-6 lg:tw-gap-2">
          @for (amount of presetAmounts; track amount) {
          <button
            type="button"
            class="tw-shrink-0 tw-snap-start tw-h-10 tw-min-w-[4.75rem] tw-px-3 lg:tw-min-w-0 lg:tw-w-full tw-rounded-lg tw-border tw-text-sm tw-font-medium tw-transition-colors tw-whitespace-nowrap"
            [ngClass]="
              !isCustomAmountActive() && selectedPresetAmount() === amount
                ? 'tw-border-blue-600 tw-bg-blue-600 tw-text-white'
                : 'tw-border-gray-200 tw-bg-gray-100 tw-text-gray-700 hover:tw-border-gray-300 dark:tw-border-gray-700 dark:tw-bg-gray-800 dark:tw-text-gray-200'
            "
            [disabled]="isConfirming()"
            (click)="selectPresetAmount(amount)"
          >
            $ {{ amount }}
          </button>
          }
        </div>
      </div>

      <basic-input
        [control]="customAmountControl"
        [fieldType]="basicFieldType.TEXT"
        [label]="'v2.orgSettings.billing.customAmount' | translate"
        [addValidationColors]="true"
        [allowClearButton]="false"
        [autocomplete]="'off'"
        (onValueChange)="onCustomAmountInput($any($event.target).value)"
      ></basic-input>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-4 tw-min-h-0">
      <p class="tw-font-medium tw-text-base tw-leading-5 tw-text-gray-900 dark:tw-text-gray-100">
        {{ 'v2.orgSettings.billing.paymentCard' | translate }}
      </p>

      @if (hasSavedCards()) {
      <div
        class="tw-flex tw-flex-col tw-gap-4 tw-min-h-0 tw-max-h-[min(280px,40vh)] tw-pr-6 tw-overflow-y-auto [scrollbar-width:thin] [-ms-overflow-style:auto] [&::-webkit-scrollbar]:tw-w-2 [&::-webkit-scrollbar-thumb]:tw-rounded-full [&::-webkit-scrollbar-thumb]:tw-bg-gray-300"
      >
        @for (method of paymentMethods(); track method.id) {
        <button
          type="button"
          class="tw-flex tw-shrink-0 tw-items-center tw-justify-between tw-gap-4 tw-p-4 tw-rounded-xl tw-border tw-text-start tw-transition-colors"
          [ngClass]="
            isSelectedCard(method)
              ? 'tw-border-blue-600 tw-bg-blue-50/40 dark:tw-bg-blue-900/10'
              : isExpired(method)
              ? 'tw-border-gray-200 tw-bg-gray-50 dark:tw-border-gray-700 dark:tw-bg-gray-800/60 tw-opacity-70'
              : 'tw-border-gray-200 tw-bg-white hover:tw-border-gray-300 dark:tw-border-gray-700 dark:tw-bg-gray-800'
          "
          [disabled]="isConfirming() || isExpired(method)"
          (click)="selectSavedCard(method)"
        >
          <div class="tw-flex tw-items-center tw-gap-4 tw-min-w-0">
            <div class="tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center tw-w-18 tw-h-11 tw-bg-white tw-rounded-lg tw-overflow-hidden">
              <img [src]="getCardBrandIconUrl()(method.brand)" alt="" class="tw-w-full tw-h-full tw-object-contain" />
            </div>

            <div class="tw-flex tw-flex-col tw-min-w-0">
              <p class="tw-font-semibold tw-text-sm lg:tw-text-base tw-leading-6 tw-text-gray-900 dark:tw-text-gray-100 tw-truncate">
                {{ formatCardBrand()(method.brand) }} •••• {{ method.last4 }}
              </p>

              @if (isExpired(method)) {
              <p class="tw-font-medium tw-text-sm tw-leading-5 tw-text-red-600">
                {{ 'v2.orgSettings.billing.cardExpired' | translate }}
              </p>
              } @else {
              <p class="tw-font-normal tw-text-sm tw-leading-5 tw-text-gray-500 dark:tw-text-gray-400">
                {{ 'v2.orgSettings.billing.cardExpiryDate' | translate }}: {{ formatCardExpiry()(method.exp_month, method.exp_year) }}
              </p>
              }
            </div>
          </div>

          @if (isDefault(method)) {
          <span class="tw-inline-flex tw-shrink-0 tw-items-center tw-rounded-md tw-bg-blue-50 tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-text-blue-700">
            {{ 'v2.orgSettings.billing.defaultPaymentCard' | translate }}
          </span>
          }
        </button>
        }
      </div>
      } @if (cardError() && !showNewCardStripe()) {
      <p class="tw-text-sm tw-leading-5 tw-text-red-600" role="alert">
        {{ cardError() }}
      </p>
      }
    </div>
  </div>
</ng-template>

<ng-template #topUpPaymentExtras>
  @if (hasSavedCards() && !showNewCardStripe()) {
  <button
    type="button"
    class="tw-flex tw-w-full tw-items-center tw-gap-3 tw-p-3 lg:tw-p-4 tw-rounded-xl tw-border tw-border-gray-200 tw-bg-white hover:tw-border-gray-300 dark:tw-border-gray-700 dark:tw-bg-gray-800 tw-text-start tw-transition-colors"
    [disabled]="isConfirming()"
    (click)="selectNewCard()"
  >
    <span class="tw-inline-flex tw-items-center tw-justify-center tw-w-[72px] tw-h-[44px] tw-rounded-md tw-bg-blue-50">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M10 4.16667V15.8333" stroke="#1C64F2" stroke-width="2" stroke-linecap="round" />
        <path d="M4.16669 10H15.8334" stroke="#1C64F2" stroke-width="2" stroke-linecap="round" />
      </svg>
    </span>
    <span class="tw-font-medium tw-text-sm lg:tw-text-base tw-text-blue-700">
      {{ 'v2.orgSettings.billing.addNewCard' | translate }}
    </span>
  </button>
  } @else if (showNewCardStripe()) {
  <div class="tw-flex tw-flex-col tw-gap-1">
    <div
      class="tw-rounded-xl tw-border tw-border-blue-600 tw-bg-white dark:tw-bg-gray-800 tw-px-4 tw-pt-6"
      [ngClass]="{
        'tw-border-red-600': cardError(),
        'tw-opacity-60': isConfirming()
      }"
    >
      @if (isInitializingStripe()) {
      <div class="tw-flex tw-flex-col tw-gap-1 tw-pb-4">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '100%',
            height: '44px',
            'border-radius': '8px',
            backgroundColor: getSkeletonTheme().backgroundColor,
            color: getSkeletonTheme().color
          }"
          animation="pulse"
        ></ngx-skeleton-loader>
      </div>
      } @else {
      <div #cardElement class="tw-min-h-11"></div>
      }
    </div>

    <p class="tw-text-sm tw-min-h-5 tw-leading-5 tw-text-red-600" role="alert">
      {{ cardError() }}
    </p>

    @if (showSetAsDefaultCheckbox()) { @if (isInitializingStripe()) {
    <div class="tw-inline-flex tw-items-center tw-gap-3">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          width: '16px',
          height: '16px',
          'border-radius': '4px',
          backgroundColor: getSkeletonTheme().backgroundColor,
          color: getSkeletonTheme().color
        }"
        animation="pulse"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          width: '220px',
          height: '16px',
          'border-radius': '6px',
          backgroundColor: getSkeletonTheme().backgroundColor,
          color: getSkeletonTheme().color
        }"
        animation="pulse"
      ></ngx-skeleton-loader>
    </div>
    } @else {
    <label class="tw-inline-flex tw-items-center tw-gap-3 tw-cursor-pointer">
      <input
        type="checkbox"
        class="tw-h-4 tw-w-4 tw-rounded tw-border-gray-300 tw-text-blue-600 focus:tw-ring-blue-500"
        [checked]="setAsDefault()"
        [disabled]="isConfirming()"
        (change)="toggleSetAsDefault($any($event.target).checked)"
      />
      <span class="tw-text-sm tw-leading-5 tw-text-gray-700 dark:tw-text-gray-300">
        {{ 'v2.orgSettings.billing.setAsDefaultPaymentCard' | translate }}
      </span>
    </label>
    } }
  </div>
  }
</ng-template>

<ng-template #topUpPrimaryActions>
  @if (embedded()) {
  <div class="tw-flex tw-w-full tw-items-stretch tw-justify-between tw-gap-4 sm:tw-items-center">
    <button
      type="button"
      class="tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-5 tw-py-2.5 tw-font-medium tw-text-gray-800 tw-shadow-none hover:tw-bg-gray-50"
      [disabled]="isConfirming()"
      (click)="cancelEmbedded()"
    >
      Back
    </button>
    @if (showNewCardStripe() && isInitializingStripe()) {
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        width: '140px',
        height: '44px',
        'border-radius': '12px',
        backgroundColor: getSkeletonTheme().backgroundColor,
        color: getSkeletonTheme().color
      }"
      animation="pulse"
    ></ngx-skeleton-loader>
    } @else {
    <button
      type="button"
      class="tw-rounded-md tw-border-0 !tw-bg-blue-600 tw-px-5 tw-py-2.5 tw-font-medium !tw-text-white tw-shadow-none hover:!tw-bg-blue-700"
      [disabled]="!canConfirm() || !!cardError()"
      (click)="confirm()"
    >
      @if (isConfirming()) {
      {{ 'v2.common.processing' | translate }}
      } @else {
      {{ 'v2.orgSettings.billing.confirmTopUp' | translate }}
      }
    </button>
    }
  </div>
  } @else if (showNewCardStripe() && isInitializingStripe()) {
  <ngx-skeleton-loader
    count="1"
    [theme]="{
      width: '100%',
      height: '48px',
      'border-radius': '12px',
      backgroundColor: getSkeletonTheme().backgroundColor,
      color: getSkeletonTheme().color
    }"
    animation="pulse"
  ></ngx-skeleton-loader>
  } @else {
  <button
    type="button"
    class="tw-w-full tw-inline-flex tw-items-center tw-justify-center tw-h-12 tw-rounded-xl tw-bg-blue-600 hover:tw-bg-blue-700 tw-transition-colors tw-font-medium tw-text-base tw-text-white"
    [disabled]="!canConfirm() || cardError()"
    (click)="confirm()"
  >
    @if (isConfirming()) {
    {{ 'v2.common.processing' | translate }}
    } @else {
    {{ 'v2.orgSettings.billing.confirmTopUp' | translate }}
    }
  </button>
  }
</ng-template>

<ng-template #topUpFooter>
  <div class="tw-w-full tw-flex tw-flex-col tw-gap-4" [class.tw-px-6]="!embedded()" [class.tw-py-4]="!embedded()">
    <ng-container *ngTemplateOutlet="topUpPaymentExtras"></ng-container>
    <ng-container *ngTemplateOutlet="topUpPrimaryActions"></ng-container>
  </div>
</ng-template>

@if (!embedded()) {
<modal
  [id]="modalId()"
  [header]="'v2.orgSettings.billing.walletTopUpModalTitle'"
  [headerIcon]="headerIcon()"
  [closeButtonEnabled]="true"
  [enableBackdropClose]="false"
  [escapeToClose]="!isConfirming()"
  [showHeaderDivider]="true"
  [showFooterDivider]="true"
  [heightClass]="'tw-max-h-[90vh] tw-flex tw-flex-col'"
  [widthClass]="'tw-w-11/12 md:tw-w-3/4 lg:tw-w-1/2 xl:tw-w-3xl tw-max-w-xl'"
  (onCloseModal)="close()"
>
  <div slot="body">
    <ng-container *ngTemplateOutlet="topUpBody"></ng-container>
  </div>
  <div slot="footer">
    <ng-container *ngTemplateOutlet="topUpFooter"></ng-container>
  </div>
</modal>
} @else if (active()) {
<div class="tw-flex tw-h-full tw-min-h-0 tw-flex-col tw-overflow-hidden">
  <div class="tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-p-6">
    <ng-container *ngTemplateOutlet="topUpBody"></ng-container>
    <div class="tw-mt-6 tw-flex tw-flex-col tw-gap-4">
      <ng-container *ngTemplateOutlet="topUpPaymentExtras"></ng-container>
    </div>
  </div>
  <div class="tw-shrink-0 tw-border-t tw-border-gray-200 tw-bg-white tw-px-6 tw-py-4">
    <ng-container *ngTemplateOutlet="topUpPrimaryActions"></ng-container>
  </div>
</div>
}
